
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 703","transform":"translate(-38 -165)"}},[_c('rect',{attrs:{"data-name":"Rectangle 1989","width":"10","height":"10","rx":"4","transform":"translate(38 165)","fill":"#999"}}),_c('rect',{attrs:{"data-name":"Rectangle 1990","width":"10","height":"10","rx":"4","transform":"translate(50 165)","fill":"#74DBB5"}}),_c('rect',{attrs:{"data-name":"Rectangle 1991","width":"10","height":"10","rx":"4","transform":"translate(50 177)","fill":"#218665"}}),_c('rect',{attrs:{"data-name":"Rectangle 1992","width":"10","height":"10","rx":"4","transform":"translate(38 177)","fill":"#0FA"}})])])
          )
        }
      }
    